import { Box, CircularProgress } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';
import { lazy, Suspense } from 'react';

const Profile = lazy(() => import('pages/profile'));

const Loader = (): JSX.Element => (
  <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
    <CircularProgress />
  </Box>
);

export const Route = createFileRoute('/_authenticated/_main/account')({
  component: ProfileWrapper,
});

function ProfileWrapper(): JSX.Element {
  return (
    <Suspense fallback={<Loader />}>
      <Profile />
    </Suspense>
  );
}
